module.exports = __webpack_public_path__ + "assets/img/detail-left-layer-1-6faf8be7.png";